import { render, staticRenderFns } from "./RecordStaff.vue?vue&type=template&id=1f8ae293&scoped=true"
import script from "./RecordStaff.vue?vue&type=script&lang=js"
export * from "./RecordStaff.vue?vue&type=script&lang=js"
import style0 from "./RecordStaff.vue?vue&type=style&index=0&id=1f8ae293&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8ae293",
  null
  
)

export default component.exports